import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody, CardImg } from "reactstrap";

import "./style.css";
// Checked and modified css

class Differentiators extends Component {
  render() {
    return (
      <div className="differentiators-section mb-0 pb-0">
        <Container>
          <Row>
            <Col sm={{ size: "12" }}>
              <Row>
                <Col>
                  <h1 className="text-center mt-5 mb-3 fc-line ">
                    Where Experience & Learning Come Together
                  </h1>
                  {/* <hr className="heading-underline mb-5" /> */}
                </Col>
              </Row>
              <Row className="pb-2 mb-lg-5">
                <Col>
                  <p className="off-white mt-3">
                    Lighthouse believes that gaining real work experience and
                    learning go hand in hand. The immersive programs we offer
                    inevitably bring best in class learning and growth, where
                    students can learn beyond the classroom, guided by the tech
                    community globally.
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="mt-5">
            <Col sm={{ size: 6 }} className="margin-between-cards d-flex">
              <Row>
                <Col
                  xs={{ size: 12 }}
                  sm={{ size: 6 }}
                  md={{size:3}}
                  className="d-flex justify-content-start align-items-start pr-0 pb-4"
                >
                  <CardImg
                    className="d-icon d-icons pr-0"
                    top
                    src="img/employer-partnership-icon.svg"
                  />
                </Col>
                <Col className="pl-lg-0">
                  <Card className="differentiators-cards">
                    <CardBody className="pt-0 card-body">
                      <h3 className="differentiators-header">
                        Employer Partnerships
                      </h3>
                      <hr className="card-line mt-1" />
                      <p className="differentiators-text">
                        The first of its kind. Our employer partnerships are
                        beyond creating talent showcases. We focus on the
                        lifetime job opportunity for everyone and work to help
                        you add the skills most demanded by our employer
                        partners even when future technology changes. Our
                        partnerships go deep to help companies keep their teams
                        relevant and adaptable with fast-changing technologies.
                        Learn more.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>

            <Col sm={{ size: 6 }} className="margin-between-cards  d-flex">
              <Row>
                <Col
                  xs={{ size: 12 }}
                  sm={{ size: 6 }}
                  md={{size:3}}
                  className="d-flex justify-content-start align-items-start pr-0 pb-4"
                >
                  <CardImg
                    className="d-icon d-icons  pr-0 pb-sm-2 "
                    top
                    src="img/mentors-for-success-icon.svg"
                  />
                </Col>
                <Col className="pl-lg-0">
                  <Card className="differentiators-cards">
                    <CardBody className="pt-0 card-body">
                      <h3 className="differentiators-header">
                        Mentors For Success
                      </h3>
                      <hr className="card-line mt-1" />
                      <p className="differentiators-text">
                        Staying relevant takes more than just learning new tech
                        skills. It is about applying them to bring business
                        success. It requires direction. Our students get
                        dedicated mentors who are industry-experienced. They
                        guide and help bring inspiration into the future.
                        Equipped with help, students can approach their careers
                        and the tech industry with unprecedented confidence.
                        There is more - one can even reach our designated
                        mentors even after graduation.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col sm={{ size: 6 }} className="margin-between-cards   d-flex">
              <Row>
                <Col
                  xs={{ size: 12 }}
                  sm={{ size: 6 }}
                  md={{size:3}}
                  className="d-flex justify-content-start align-items-start pl-1 pr-0 pb-lg-4"
                >
                  <CardImg
                    className=" d-icon d-icons  pr-0"
                    top
                    src="img/CIO-icon.svg"
                  />
                </Col>
                <Col className="pl-lg-0">
                  <Card className="differentiators-cards">
                    <CardBody className="pt-0 card-body">
                      <h3 className="differentiators-header">
                        CIO Defined Curriculum
                      </h3>
                      <hr className="card-line mt-1" />
                      <p className="differentiators-text">
                        Our programs provide a deeper immersion into the
                        industry by incorporating problem-solving challenges and
                        lessons on top-level thinking from a tech leader’s point
                        of view. With real jobs demanding productivity, ability
                        to build experiential and intelligent applications – the
                        curriculum needs to match the real world. Our CIO
                        advisors have helped create a carefully curated
                        curriculum. Indeed, we want you to be prepared and ready
                        to succeed.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
            <Col sm={{ size: 6 }} className="margin-between-cards d-flex">
              <Row>
                <Col
                  xs={{ size: 12 }}
                  sm={{ size: 6 }}
                  md={{size:3}}
                  className="d-flex justify-content-start align-items-start pr-0 pb-4 pb-sm-4"
                >
                  <CardImg
                    className=" d-icon d-icon4  pr-0"
                    top
                    src="img/ISA-icon.svg"
                  />
                </Col>
                <Col className="pl-lg-0">
                  <Card className="differentiators-cards">
                    <CardBody className=" pt-0 card-body">
                      <h3 className="differentiators-header">
                        Grow Your Career Not Debt
                      </h3>
                      <hr className="card-line mt-1" />
                      <p className="differentiators-text">
                      Lighthouse focuses on evolving your career based on what skills market needs the most. Our mindset is that once accepted - Then we will be your guide throughout your career as it evolves. Call it, our focus on the lifetime job opportunity for a student. How do we make it easier for our students to learn newer tech-skills after they start their tech careers? It is beyond financing options and ISAs, which we do offer. Learn more about, how we work to help you - Stay Relevant, Forever™.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Differentiators;
